import { TeamCard } from '@kkf/design'
import { TEAM_MEMBERS } from '../data/team'
import { useT } from '../i18n'

/** The team page. */
export function TeamPage() {
  const t = useT()
  return (
    <>
      {/*
        No banner and no breadcrumb (2026-09-21), the way `/about`, `/contact`, `/blog` and
        the legal pair lost theirs. `Breadcrumb` IS the photographic band — the trail sat
        inside it — so both went together. Two things travel with that, and each passes
        every gate this repo has:

        1. **It carried the page's only `<h1>`.** `audit:seo` fails a page with any number
           other than one, so the title is `.ul-plain-page-title` here — the class that
           exists for exactly this, beside `.ul-plain-page-top` in `_header.scss`.
        2. **The page now opens pale**, and the header's links are white at rest because
           the usual first section is a dark band. This route is in `header.plainRoutes`
           in `data/shell` as of the same day. Forget that and every link in the nav is
           white on near-white, and nothing anywhere goes red.
      */}
      <section className="ul-plain-page-top ul-team ul-inner-team ul-section-spacing">
        <div className="ul-container">
          <h1 className="ul-plain-page-title">{t('page.team')}</h1>
          <div className="row row-cols-md-4 row-cols-sm-3 row-cols-2 row-cols-xxs-1 ul-team-row justify-content-center">
            {TEAM_MEMBERS.map((member) => (
              <div className="col" key={member.image}>
                <TeamCard {...member} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
